// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
In general, most of the styling should be achieved via inline Elm/JS styles,
and you should not use this file.

However, there are some CSS features which are not available using inline
styles. For example, pseudo selectors like "hover", "active", etc.
and handling "dark mode" via media query. In which case, put them here.

ABOUT DARK MODE

Dark mode is implemented in 2 steps:

 (1) The Gym app's \`index.js\` imports either a light or a dark Bootstrap theme
     based on the presence or absence of the "prefers-color-scheme" media query.
     This gets us 95% of the way to having an app that looks good in both light
     and dark modes.

 (2) This CSS file defines CSS variables which can be used by the Elm app code
     to handle cases which are not covered by the out-of-the-box Bootstrap theme CSS.
*/
:root {
        /* 'Flatly' Bootswatch/Bootstrap theme */
        --pl-page-bg-color: white;
        --pl-page-bg-color-secondary: #ecf0f1;
        --pl-text-color: #2c3e50;
        --pl-text-color-secondary: #777;
        --pl-primary-color: #2c3e50;
        --pl-info-color: #3498DB;
        --pl-warning-color: #f39c12;
        --pl-danger-color: #e74c3c;

        /* Random PowerLift stuff */
        --pl-visited-link-color: #266ea0;
        --pl-accent-bg-color-light: #E9F3FB;
        --pl-btn-borderless-color: #555;
        --pl-semi-transparent-border: rgba(0, 0, 0, 0.1);
        --pl-click-to-classify-bg-color: #fffcbf;
        --pl-click-to-classify-text-color-bg: #2c3e50;

        /* Subdued PowerLift buttons */
        --pl-btn-subdued-neutral-bg-color: #eaeaea;
        --pl-btn-subdued-neutral-text-color: #636363;
        --pl-btn-subdued-neutral-hover-bg-color: #c0c0c0;
        --pl-btn-subdued-neutral-hover-text-color: #4d4d4d;

        --pl-btn-subdued-green-bg-color: #dff0d8;
        --pl-btn-subdued-green-text-color: #3c763d;
        --pl-btn-subdued-green-hover-bg-color: #7eba7f;
        --pl-btn-subdued-green-hover-text-color: #24602a;

        /* JsonTree styles */
        --pl-json-tree-string: #2c3e50;
        --pl-json-tree-number: #e74c3c;
        --pl-json-tree-bool: #f39c12;
        --pl-json-tree-null: #b4bcc2;
}

@media (prefers-contrast: high) or (prefers-color-scheme: dark)  {
    :root {
        /* 'Darkly' Bootswatch/Bootstrap theme */
        --pl-page-bg-color: #222;
        --pl-page-bg-color-secondary: #303030;
        --pl-text-color: #fff;
        --pl-text-color-secondary: #aaa;
        --pl-primary-color: #375a7f;
        --pl-info-color: #3498DB;
        --pl-warning-color: #f39c12;
        --pl-danger-color: #e74c3c;

        /* Random PowerLift stuff */
        --pl-visited-link-color: #0bb386;
        --pl-accent-bg-color-light: #243947;
        --pl-btn-borderless-color: #ccc;
        --pl-semi-transparent-border: rgba(255, 255, 255, 0.1);
        --pl-click-to-classify-bg-color: #fffdbc;
        --pl-click-to-classify-text-color-bg: #000;

        /* Subdued PowerLift buttons */
        --pl-btn-subdued-neutral-bg-color: #7a7a7a;
        --pl-btn-subdued-neutral-text-color: #000;
        --pl-btn-subdued-neutral-hover-bg-color: #5d5d5d;
        --pl-btn-subdued-neutral-hover-text-color: #000;

        --pl-btn-subdued-green-bg-color: #b1beab;
        --pl-btn-subdued-green-text-color: #2f5d30;
        --pl-btn-subdued-green-hover-bg-color: #6a9d6b;
        --pl-btn-subdued-green-hover-text-color: #1a451e;

        /* JsonTree styles  */
        --pl-json-tree-string: #3498db;
        --pl-json-tree-number: #f39c12;
        --pl-json-tree-bool: #e74c3c;
        --pl-json-tree-null: #999;
    }

    /* There's a bug in the 'Darkly' Bootswatch theme that causes select option text to be white
    on a light background and therefore nearly impossible to read. So we override to make it dark. */
    select {
        color: #222;
    }
}

/* Apply a special link color when ':visited' only when requested explicitly */
.trackedLink:visited {
    color: var(--pl-visited-link-color)
}

/* Hover widget for building a classifier from elements of the JSON tree view */
.clickToClassifyNode:hover {
    background-color: var(--pl-click-to-classify-bg-color);
    color: var(--pl-click-to-classify-text-color-bg);
    cursor: pointer;
}

/* Hover hint for indicating that an element in the remedy editor is selectable*/
.remedyEditorElement:hover {
    background-color: rgba(255, 245, 51, 0.4);
    cursor: pointer;
}

/** Custom button colors */

.btn-subdued-neutral {
    background-color: var(--pl-btn-subdued-neutral-bg-color);
    color: var(--pl-btn-subdued-neutral-text-color);
}

.btn-subdued-neutral:hover {
    background-color: var(--pl-btn-subdued-neutral-hover-bg-color);
    color: var(--pl-btn-subdued-neutral-hover-text-color);
}

.btn-subdued-green {
    background-color: var(--pl-btn-subdued-green-bg-color);
    color: var(--pl-btn-subdued-green-text-color);
}

.btn-subdued-green:hover {
    background-color: var(--pl-btn-subdued-green-hover-bg-color);
    color: var(--pl-btn-subdued-green-hover-text-color);
}

/* like btn-link, but with a normal text color and hover causes bg color to change */
.btn-borderless {
    font-weight: 400;
    color: var(--pl-btn-borderless-color);
}

.btn-borderless,
.btn-borderless.active,
.btn-borderless:active,
.btn-borderless[disabled],
fieldset[disabled] .btn-borderless {
    background-color: transparent;
    box-shadow: none;
}

.btn-borderless {
    border-color: transparent;
}

.btn-borderless.active,
.btn-borderless:active,
.btn-borderless:focus,
.btn-borderless:hover {
    color: var(--pl-text-color);
    background-color: rgba(0, 0, 0, 0.12);
}

.active .btn-borderless {
    color: white;
}`, "",{"version":3,"sources":["webpack://./gym-client/gym.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;CAmBC;AACD;QACQ,wCAAwC;QACxC,yBAAyB;QACzB,qCAAqC;QACrC,wBAAwB;QACxB,+BAA+B;QAC/B,2BAA2B;QAC3B,wBAAwB;QACxB,2BAA2B;QAC3B,0BAA0B;;QAE1B,2BAA2B;QAC3B,gCAAgC;QAChC,mCAAmC;QACnC,+BAA+B;QAC/B,gDAAgD;QAChD,wCAAwC;QACxC,6CAA6C;;QAE7C,8BAA8B;QAC9B,0CAA0C;QAC1C,4CAA4C;QAC5C,gDAAgD;QAChD,kDAAkD;;QAElD,wCAAwC;QACxC,0CAA0C;QAC1C,8CAA8C;QAC9C,gDAAgD;;QAEhD,oBAAoB;QACpB,8BAA8B;QAC9B,8BAA8B;QAC9B,4BAA4B;QAC5B,4BAA4B;AACpC;;AAEA;IACI;QACI,wCAAwC;QACxC,wBAAwB;QACxB,qCAAqC;QACrC,qBAAqB;QACrB,+BAA+B;QAC/B,2BAA2B;QAC3B,wBAAwB;QACxB,2BAA2B;QAC3B,0BAA0B;;QAE1B,2BAA2B;QAC3B,gCAAgC;QAChC,mCAAmC;QACnC,+BAA+B;QAC/B,sDAAsD;QACtD,wCAAwC;QACxC,0CAA0C;;QAE1C,8BAA8B;QAC9B,0CAA0C;QAC1C,yCAAyC;QACzC,gDAAgD;QAChD,+CAA+C;;QAE/C,wCAAwC;QACxC,0CAA0C;QAC1C,8CAA8C;QAC9C,gDAAgD;;QAEhD,qBAAqB;QACrB,8BAA8B;QAC9B,8BAA8B;QAC9B,4BAA4B;QAC5B,yBAAyB;IAC7B;;IAEA;oGACgG;IAChG;QACI,WAAW;IACf;AACJ;;AAEA,8EAA8E;AAC9E;IACI;AACJ;;AAEA,+EAA+E;AAC/E;IACI,sDAAsD;IACtD,gDAAgD;IAChD,eAAe;AACnB;;AAEA,gFAAgF;AAChF;IACI,yCAAyC;IACzC,eAAe;AACnB;;AAEA,0BAA0B;;AAE1B;IACI,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,8DAA8D;IAC9D,qDAAqD;AACzD;;AAEA;IACI,sDAAsD;IACtD,6CAA6C;AACjD;;AAEA;IACI,4DAA4D;IAC5D,mDAAmD;AACvD;;AAEA,oFAAoF;AACpF;IACI,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;;;;;IAKI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/*\nIn general, most of the styling should be achieved via inline Elm/JS styles,\nand you should not use this file.\n\nHowever, there are some CSS features which are not available using inline\nstyles. For example, pseudo selectors like \"hover\", \"active\", etc.\nand handling \"dark mode\" via media query. In which case, put them here.\n\nABOUT DARK MODE\n\nDark mode is implemented in 2 steps:\n\n (1) The Gym app's `index.js` imports either a light or a dark Bootstrap theme\n     based on the presence or absence of the \"prefers-color-scheme\" media query.\n     This gets us 95% of the way to having an app that looks good in both light\n     and dark modes.\n\n (2) This CSS file defines CSS variables which can be used by the Elm app code\n     to handle cases which are not covered by the out-of-the-box Bootstrap theme CSS.\n*/\n:root {\n        /* 'Flatly' Bootswatch/Bootstrap theme */\n        --pl-page-bg-color: white;\n        --pl-page-bg-color-secondary: #ecf0f1;\n        --pl-text-color: #2c3e50;\n        --pl-text-color-secondary: #777;\n        --pl-primary-color: #2c3e50;\n        --pl-info-color: #3498DB;\n        --pl-warning-color: #f39c12;\n        --pl-danger-color: #e74c3c;\n\n        /* Random PowerLift stuff */\n        --pl-visited-link-color: #266ea0;\n        --pl-accent-bg-color-light: #E9F3FB;\n        --pl-btn-borderless-color: #555;\n        --pl-semi-transparent-border: rgba(0, 0, 0, 0.1);\n        --pl-click-to-classify-bg-color: #fffcbf;\n        --pl-click-to-classify-text-color-bg: #2c3e50;\n\n        /* Subdued PowerLift buttons */\n        --pl-btn-subdued-neutral-bg-color: #eaeaea;\n        --pl-btn-subdued-neutral-text-color: #636363;\n        --pl-btn-subdued-neutral-hover-bg-color: #c0c0c0;\n        --pl-btn-subdued-neutral-hover-text-color: #4d4d4d;\n\n        --pl-btn-subdued-green-bg-color: #dff0d8;\n        --pl-btn-subdued-green-text-color: #3c763d;\n        --pl-btn-subdued-green-hover-bg-color: #7eba7f;\n        --pl-btn-subdued-green-hover-text-color: #24602a;\n\n        /* JsonTree styles */\n        --pl-json-tree-string: #2c3e50;\n        --pl-json-tree-number: #e74c3c;\n        --pl-json-tree-bool: #f39c12;\n        --pl-json-tree-null: #b4bcc2;\n}\n\n@media (prefers-contrast: high) or (prefers-color-scheme: dark)  {\n    :root {\n        /* 'Darkly' Bootswatch/Bootstrap theme */\n        --pl-page-bg-color: #222;\n        --pl-page-bg-color-secondary: #303030;\n        --pl-text-color: #fff;\n        --pl-text-color-secondary: #aaa;\n        --pl-primary-color: #375a7f;\n        --pl-info-color: #3498DB;\n        --pl-warning-color: #f39c12;\n        --pl-danger-color: #e74c3c;\n\n        /* Random PowerLift stuff */\n        --pl-visited-link-color: #0bb386;\n        --pl-accent-bg-color-light: #243947;\n        --pl-btn-borderless-color: #ccc;\n        --pl-semi-transparent-border: rgba(255, 255, 255, 0.1);\n        --pl-click-to-classify-bg-color: #fffdbc;\n        --pl-click-to-classify-text-color-bg: #000;\n\n        /* Subdued PowerLift buttons */\n        --pl-btn-subdued-neutral-bg-color: #7a7a7a;\n        --pl-btn-subdued-neutral-text-color: #000;\n        --pl-btn-subdued-neutral-hover-bg-color: #5d5d5d;\n        --pl-btn-subdued-neutral-hover-text-color: #000;\n\n        --pl-btn-subdued-green-bg-color: #b1beab;\n        --pl-btn-subdued-green-text-color: #2f5d30;\n        --pl-btn-subdued-green-hover-bg-color: #6a9d6b;\n        --pl-btn-subdued-green-hover-text-color: #1a451e;\n\n        /* JsonTree styles  */\n        --pl-json-tree-string: #3498db;\n        --pl-json-tree-number: #f39c12;\n        --pl-json-tree-bool: #e74c3c;\n        --pl-json-tree-null: #999;\n    }\n\n    /* There's a bug in the 'Darkly' Bootswatch theme that causes select option text to be white\n    on a light background and therefore nearly impossible to read. So we override to make it dark. */\n    select {\n        color: #222;\n    }\n}\n\n/* Apply a special link color when ':visited' only when requested explicitly */\n.trackedLink:visited {\n    color: var(--pl-visited-link-color)\n}\n\n/* Hover widget for building a classifier from elements of the JSON tree view */\n.clickToClassifyNode:hover {\n    background-color: var(--pl-click-to-classify-bg-color);\n    color: var(--pl-click-to-classify-text-color-bg);\n    cursor: pointer;\n}\n\n/* Hover hint for indicating that an element in the remedy editor is selectable*/\n.remedyEditorElement:hover {\n    background-color: rgba(255, 245, 51, 0.4);\n    cursor: pointer;\n}\n\n/** Custom button colors */\n\n.btn-subdued-neutral {\n    background-color: var(--pl-btn-subdued-neutral-bg-color);\n    color: var(--pl-btn-subdued-neutral-text-color);\n}\n\n.btn-subdued-neutral:hover {\n    background-color: var(--pl-btn-subdued-neutral-hover-bg-color);\n    color: var(--pl-btn-subdued-neutral-hover-text-color);\n}\n\n.btn-subdued-green {\n    background-color: var(--pl-btn-subdued-green-bg-color);\n    color: var(--pl-btn-subdued-green-text-color);\n}\n\n.btn-subdued-green:hover {\n    background-color: var(--pl-btn-subdued-green-hover-bg-color);\n    color: var(--pl-btn-subdued-green-hover-text-color);\n}\n\n/* like btn-link, but with a normal text color and hover causes bg color to change */\n.btn-borderless {\n    font-weight: 400;\n    color: var(--pl-btn-borderless-color);\n}\n\n.btn-borderless,\n.btn-borderless.active,\n.btn-borderless:active,\n.btn-borderless[disabled],\nfieldset[disabled] .btn-borderless {\n    background-color: transparent;\n    box-shadow: none;\n}\n\n.btn-borderless {\n    border-color: transparent;\n}\n\n.btn-borderless.active,\n.btn-borderless:active,\n.btn-borderless:focus,\n.btn-borderless:hover {\n    color: var(--pl-text-color);\n    background-color: rgba(0, 0, 0, 0.12);\n}\n\n.active .btn-borderless {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
